import React from 'react';
import Icon from '../../../components/AppIcon';
import { formatCurrency } from '../../../utils/currency';

const SummaryCard = ({ title, amount, currency, type, trend, comparison }) => {
  const getCardStyles = () => {
    switch (type) {
      case 'income':
        return {
          bgColor: 'bg-success/10',
          iconColor: 'var(--color-success)',
          textColor: 'text-success',
          icon: 'TrendingUp'
        };
      case 'expense':
        return {
          bgColor: 'bg-error/10',
          iconColor: 'var(--color-error)',
          textColor: 'text-error',
          icon: 'TrendingDown'
        };
      case 'net':
        return {
          bgColor: amount >= 0 ? 'bg-primary/10' : 'bg-warning/10',
          iconColor: amount >= 0 ? 'var(--color-primary)' : 'var(--color-warning)',
          textColor: amount >= 0 ? 'text-primary' : 'text-warning',
          icon: amount >= 0 ? 'DollarSign' : 'AlertCircle'
        };
      case 'transactions':
        return {
          bgColor: 'bg-accent/10',
          iconColor: 'var(--color-accent)',
          textColor: 'text-accent',
          icon: 'Receipt'
        };
      default:
        return {
          bgColor: 'bg-muted',
          iconColor: 'var(--color-foreground)',
          textColor: 'text-foreground',
          icon: 'DollarSign'
        };
    }
  };

  const styles = getCardStyles();
  const formattedAmount = type === 'transactions' ?
  amount?.toLocaleString() :
  formatCurrency(Math.abs(amount), currency);

  const trendIcon = trend > 0 ? 'ArrowUp' : trend < 0 ? 'ArrowDown' : 'Minus';
  const trendColor = trend > 0 ? 'text-success' : trend < 0 ? 'text-error' : 'text-muted-foreground';

  return (
    <div className="bg-card rounded-xl p-24 md:p-28 shadow-sm hover:shadow-md transition-all duration-200 border border-border/50 hover:border-border">
      <div className="flex items-start justify-between mb-20">
        <div className="flex-1">
          <h3 className="text-xs md:text-sm font-caption font-medium text-muted-foreground mb-10 uppercase tracking-wide">
            {title}
          </h3>
          <p className={`text-2xl md:text-3xl font-heading font-bold ${styles?.textColor} leading-tight`}>
            {type === 'expense' && amount > 0 ? '-' : ''}{formattedAmount}
          </p>
        </div>
        <div className={`flex items-center justify-center w-12 h-12 md:w-14 md:h-14 ${styles?.bgColor} rounded-lg flex-shrink-0`}>
          <Icon name={styles?.icon} size={22} color={styles?.iconColor} strokeWidth={2.5} />
        </div>
      </div>
      {comparison !== 0 && comparison &&
      <div className="flex items-center gap-8 pt-16 border-t border-border/50">
          <Icon name={trendIcon} size={14} color={trend > 0 ? 'var(--color-success)' : trend < 0 ? 'var(--color-error)' : 'var(--color-muted-foreground)'} />
          <span className={`text-xs font-caption font-medium ${trendColor}`}>
            {Math.abs(trend)}% vs last month
          </span>
          <span className="text-xs text-muted-foreground">
            ({comparison})
          </span>
        </div>
      }
    </div>);

};

export default SummaryCard;